import { AxiosError } from 'axios';
import { BaseClient } from '../client';
import { IndicacaoApiResponse, IndicacaoSolicitacaoGanhos } from './indicacao.types';

export const getIndicacaoSolicitacaoGanhos = async (id: number) => {
	try {
		const response = await BaseClient.get<IndicacaoApiResponse<IndicacaoSolicitacaoGanhos>>(
			`v2/Indicacao/Solicitacao/${id}/Ganhos`
		);
		return response.data;
	} catch (error) {
		const axiosError = error as AxiosError<IndicacaoApiResponse<IndicacaoSolicitacaoGanhos>>;
		if (axiosError.response?.data?.message) {
			return axiosError.response.data;
		}
		throw error;
	}
};
